import React from 'react'

const HorizontalPlayerCard = (props) => {
    const player = props.player;
    return (
        <div className="horizontal-player-card glass">
            <img src={`https://res.cloudinary.com/dfwh8gb6y/image/upload/w_100,h_100/v1635448141/${parseInt(player._id)}.png`}/>
            <div className="player-details-hcard">
                <div>{player.name}</div>
                <div>{player.format}</div>
            </div>
        </div>
    )
}

export default HorizontalPlayerCard
